import { useEffect } from 'react';
import { connectWS } from '../services/ws';
import { useCookiesLogin } from '../config/cookies';
import { usePayment } from '../context/PaymentContext';

export function usePaymentMonitor() {
  const { cookies } = useCookiesLogin();
  const token = cookies.AUTH_TOKEN?.token;

  const { subscriptionId, setPaymentStatus } = usePayment();

  useEffect(() => {
    if (!token || !subscriptionId) return;

    const ws = connectWS(token);
    const channel = ws.subscribe(`payment:${subscriptionId}`);

    channel.on('paid', (data) => {
      setPaymentStatus('PAID');
    });

    channel.on('error', (err) => {
      console.error('Erro no canal WebSocket:', err);
    });

    return () => {
      ws.close();
    };
  }, [subscriptionId, token, setPaymentStatus]);
}
